import { UseMutationResult, useMutation } from 'react-query'
import useAxios from './useAxios'
import { ContactFormFields } from './useContactFormValidation'

interface ContactPayloadZJ extends ContactFormFields {
  recaptcha_token: string
}
interface ContactPayloadCommon extends ContactFormFields {
  grecaptcha3_tok: string
  site_domain: string
}

export default function useContactMutation(): UseMutationResult<
  void,
  unknown,
  {
    endpoint: string
    payload: ContactPayloadZJ | ContactPayloadCommon
  },
  unknown
> {
  const axios = useAxios()

  return useMutation({
    mutationFn: async ({
      endpoint,
      payload,
    }: {
      endpoint: string
      payload: ContactPayloadZJ | ContactPayloadCommon
    }) => {
      await axios.post(endpoint, payload)
    },
  })
}
